import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as MirrorIcon } from 'assets/icons/mirror_horizontal.svg';
import { AltTextMenu } from 'modules/Editor/components/Toolbar/AltTextMenu/AltTextMenu';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { useTranslation } from 'react-i18next';
import { LineWidgetData } from 'widgets/Lines/LineWidget/LineWidget.types';
import { ReplaceButton } from 'widgets/sdk';
import { useWidget } from 'widgets/sdk/useWidget';

import { LineToolbarOptions, LineWidgetToolbarContent } from '../common/toolbar/CommonLineToolbarContent';
import { LineIconWidgetData } from './LineIconWidget.types';

export const LineIconWidgetToolbar = () => {
  const { widgetId, strokeColor, strokeWidth, startArrowStyle, strokeDashType, endArrowStyle, updateWidget } =
    useWidget<LineIconWidgetData>();
  return (
    <Flex mr='8px' gap='8px' align='center'>
      <ReplaceButton />
      <MirrorMenu />
      <LineWidgetToolbarContent
        values={{
          strokeColor,
          strokeWidth,
          startArrowStyle,
          strokeDashType,
          endArrowStyle,
        }}
        onUpdate={updateWidget as (updateData: Partial<Omit<LineWidgetData, 'type'>>) => void}
        hiddenOptions={[LineToolbarOptions.lineType]}
      />

      <ToolbarDivider />
      <AltTextMenu widgetId={widgetId} />
    </Flex>
  );
};

const MirrorMenu = () => {
  const { t } = useTranslation('editor_widget_toolbar', { useSuspense: false, keyPrefix: 'iconToolbar' });

  const { mirror, updateWidget } = useWidget<LineIconWidgetData>();
  const onUpdateIconMirror = () => updateWidget({ mirror: { isHorizontal: !mirror?.isHorizontal } });

  if (typeof mirror?.isHorizontal !== 'boolean') return null;

  return (
    <Tooltip hasArrow placement='bottom' label={t('mirror.tooltip')} bg='black'>
      <IconButton
        onClick={onUpdateIconMirror}
        size='sm'
        aria-label={t('mirror.ariaLabel')}
        variant='icon-btn-toolbar-option'
        icon={<MirrorIcon />}
      />
    </Tooltip>
  );
};
